<div *ngIf="!slideShowOnly">
  <div *ngIf="hasPhoto; else noPhoto">
    <div *ngIf="canUpdateProperty" class="action">
      <button
        mat-mini-fab
        [class]="'btn-action ' + (multiselectEnabled ? 'enabled' : 'disabled')"
        color="primary"
        [appTooltip]="
          (multiselectEnabled ? 'Désactiver' : 'Activer') +
          ' la multi-sélection'
        "
        (click)="toggleMultiSelect()"
      >
        <mat-icon>format_list_bulleted</mat-icon>
      </button>
      <button
        mat-mini-fab
        *ngIf="multiselectEnabled"
        [class]="'btn-action'"
        [disabled]="deletingPhotos || selectedPhotos.length === 0"
        color="primary"
        appTooltip="Supprimer les photos sélectionnées"
        (click)="deleteSelectedPhotos()"
      >
        <mat-icon>delete_forever</mat-icon>
      </button>
      <app-data-loading *ngIf="deletingPhotos"></app-data-loading>
    </div>
    <mat-accordion multi>
      <ng-container *ngFor="let photoCateg of photoCategories">
        <mat-expansion-panel
          *ngIf="photoCateg.photos.length > 0"
          [expanded]="photoCateg.expanded"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ photoCateg.name }}
            </mat-panel-title>
            <mat-panel-description class="no-mobile">
              {{ photoCateg.panelDescription }}
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="row">
            <div
              *ngFor="
                let photo of photoCateg.photos;
                let index = index;
                let isFirst = first;
                let isLast = last
              "
              class="col-sm-6 col-lg-4 col-xl-3"
            >
              <app-property-photo-card
                [prop]="prop"
                [photo]="photo"
                [order]="index + 1"
                [isFirst]="isFirst"
                [isLast]="isLast"
                [enableSelection]="multiselectEnabled"
                (photoUpdated)="photoUpdated()"
                (mainPhotoUpdated)="mainPhotoIsUpdated()"
                (photoClick)="showImage(photo)"
                (photoSelected)="toggleSelectPhoto(photo)"
              ></app-property-photo-card>
            </div>
          </div>
        </mat-expansion-panel>
      </ng-container>
    </mat-accordion>
  </div>
  <ng-template #noPhoto>
    <span class="no-content">Aucune photo n'a été chargée</span>
  </ng-template>
</div>
